<script>
import {mapState} from "vuex";

export default {
  name: "Logout",
  data: () => ({
    errors: []
  }),
  computed: mapState(["continueHref"]),
  created(){
    this.$store.dispatch('Logout', {})
    .then(() => {
      this.errors = []
      if (this.continueHref) {
        window.location.href = this.continueHref
      } else {
        this.$router.push({ name: 'home' })
      }
    })
    .catch(errors => {
      console.log(errors)
      this.errors = errors
      this.$store.dispatch("addNotification", {
        type: 'error',
        message: 'Unable to logout.'
      });
      this.$router.push({ name: 'login' })
    })
  }
};
</script>